import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { Device } from '../../types/device';
import { validation } from '../registration-rules';

const RegistrationDevicesYup = (installationDate?: string) => {
  const { t } = useTranslation('registrations');
  const yupValidation = yup.object({
    devices: yup
      .array()
      .of(yup.mixed<Device>().required())
      .test(
        'delivery-date-not-after-installation-date',
        t('registrations.general.errorDeviceInvalidDeliveryDate'),
        (devices) =>
        (devices ?? []).every((device) => {
          if (!device?.deliverDate || !installationDate) return true;
          return new Date(device.deliverDate) <= new Date(installationDate);
        })
      ),
    deviceSerialNumber: yup
      .string()
      .min(validation.serialNumber.min)
      .max(validation.serialNumber.max)
      .default('')
      // Tests that the value of deviceSerialNumber is not in devices array
      .when('devices', (devices: Device[], _schema: yup.AnySchema) => {
        return _schema.test({
          test: (deviceSerialNumber: string) => !devices.find((device) => device.serialNumber === deviceSerialNumber),
          message: t('registrations.general.errorDeviceAlreadyAdded', {
            // eslint-disable-next-line no-template-curly-in-string
            item: '${originalValue}'
          })
        });
      })
  });

  return yupValidation;
};
export default RegistrationDevicesYup;
